import { render, staticRenderFns } from "./LayoutVertical.vue?vue&type=template&id=79f26828&scoped=true&"
import script from "./LayoutVertical.vue?vue&type=script&lang=js&"
export * from "./LayoutVertical.vue?vue&type=script&lang=js&"
import style0 from "./LayoutVertical.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LayoutVertical.vue?vue&type=style&index=1&id=79f26828&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f26828",
  null
  
)

export default component.exports